import { VEHICLE_STATUS } from 'constants/vehicle';

const BASE_DEAL_CONTEXT = {
	dealership_name: 'Sunset Hills Subaru of New England',
	dealership_id: 81001,
	current_request: {
		requested_amount: 1250,
		reason: 'win back',
		requested_by: 'Megan Carter',
		sale_label: 'Absolute sale',
		amount: 22000,
		timestamp: '07/24 10:00 am',
	},
};

const BASE_OFFER_CONTEXT = {
	dealership_name: 'Sunset Hills Subaru of New England',
	dealership_id: 81001,
	current_request: {
		requested_amount: 1250,
		reason: 'win back',
		requested_by: 'Megan Carter',
		sale_label: 'High offer',
		amount: 22000,
		timestamp: '07/24 10:00 am',
	},
};

const BASE_MODAL_HEADER_DATA = {
	dealership_name: BASE_DEAL_CONTEXT.dealership_name,
	highest_offerer_dealership_name: 'Acme Buyer Group',
	max_bid_amount: 21450,
	max_bid_show_to_seller: true,
	highest_offer_amount: 20900,
	effective_starting_bid_amount: 19800,
	lowest_counter_amount: 21200,
	vehicle_status: 'active',
};

const APPROVAL_REQUEST_SUMMARY = {
	ABSOLUTE_SALE_GUARANTEE: {
		absolute_sale_guarantee: {
			status: 'pending',
		},
	},
	BUY_FEE_DISCOUNT: {
		buy_fee_discount: {
			status: 'pending',
		},
	},
};

const RAW_DISCOUNT_CARD_MOCK_ROWS = [
	{
		id: 101,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.ABSOLUTE_SALE_GUARANTEE,
		sale_type_auction: false,
		vehicle_status: VEHICLE_STATUS.sold,
		vehicle_id: 70001,
		vehicle_title: '2014 Subaru Impreza Sport Premium',
		vehicle_vin: 'JF1GPAM62E8292185',
		vehicle_mileage: 149832,
		vehicle_financial_datum: {
			avg_value: 16800,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				requested_amount: 1380,
				absolute_sale_guarantee_status: 'denied',
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				status: null,
			},
		},
		activity_history: {
			sold_item: {
				side: 'asg',
				sold_amount: 22000,
				discount_amount: 1380,
				total_amount: 22000,
				timestamp: '07/24 11:22 am',
			},
			request_items: [
				{
					side: 'asg',
					status: 'denied',
					requested_amount: 1380,
					timestamp: '07/24 04:32 pm',
					occurred_at: '2026-07-24T16:32:00.000-05:00',
				},
			],
		},
	},
	{
		id: 102,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.ABSOLUTE_SALE_GUARANTEE,
		sale_type_auction: true,
		vehicle_status: VEHICLE_STATUS.active,
		vehicle_id: 70002,
		vehicle_title: '2018 Honda Civic EX',
		vehicle_vin: '19XFC2F78JE245671',
		vehicle_mileage: 88541,
		vehicle_financial_datum: {
			avg_value: 14350,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				requested_amount: 1175,
				absolute_sale_guarantee_status: 'requested',
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				status: null,
			},
		},
		activity_history: {
			sold_item: {
				side: 'asg',
				sold_amount: 21600,
				discount_amount: 1175,
				total_amount: 21600,
				timestamp: '05/20 02:15 pm',
			},
			request_items: [],
		},
	},
	{
		id: 103,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.ABSOLUTE_SALE_GUARANTEE,
		sale_type_auction: false,
		vehicle_status: VEHICLE_STATUS.sold,
		vehicle_id: 70003,
		vehicle_title: '2017 Toyota RAV4 XLE',
		vehicle_vin: 'JTMWFREV7HJ702411',
		vehicle_mileage: 102109,
		vehicle_financial_datum: {
			avg_value: 19100,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				requested_amount: 1520,
				absolute_sale_guarantee_status: 'processed',
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				status: null,
			},
		},
		activity_history: {
			request_items: [
				{
					side: 'asg',
					status: 'approved',
					requested_amount: '$1,520',
					timestamp: '07/26 09:12 am',
					occurred_at: '2026-07-26T09:12:00.000-05:00',
				},
			],
		},
	},
	{
		id: 104,
		...BASE_MODAL_HEADER_DATA,
		sale_type_auction: true,
		vehicle_status: VEHICLE_STATUS.sold,
		vehicle_id: 70004,
		vehicle_title: '2020 Nissan Altima S',
		vehicle_vin: '1N4BL4BV1LC127318',
		vehicle_mileage: 62408,
		vehicle_financial_datum: {
			avg_value: 20400,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				asg_requested: '$1,290',
				absolute_sale_guarantee_status: 'ready',
			},
			previous_request: {
				absolute_sale_guarantee_status: 'denied',
				asg_requested: '$940',
				rep_name: 'Requested for win back',
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				status: null,
			},
		},
		activity_history: {
			sold_item: {
				side: 'asg',
				sold_amount: 23000,
				discount_amount: 1520,
				total_amount: 22000,
				timestamp: '07/24 11:22 am',
			},
			request_items: [
				{
					side: 'asg',
					status: 'approved',
					requested_amount: 1520,
					timestamp: '07/26 09:12 am',
					occurred_at: '2026-07-26T09:12:00.000-05:00',
				},
			],
		},
	},
	{
		id: 105,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.ABSOLUTE_SALE_GUARANTEE,
		sale_type_auction: true,
		vehicle_status: VEHICLE_STATUS.sold,
		vehicle_id: 70004,
		vehicle_title: '2020 Nissan Altima S',
		vehicle_vin: '1N4BL4BV1LC127318',
		vehicle_mileage: 62408,
		vehicle_financial_datum: {
			avg_value: 20400,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				requested_amount: 1290,
				absolute_sale_guarantee_status: 'ready',
			},
			previous_request: {
				absolute_sale_guarantee_status: 'denied',
				requested_amount: 940,
				reason: 'win back',
				requested_by: 'Megan Carter',
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				status: null,
			},
		},
		activity_history: {
			sold_item: {
				side: 'asg',
				sold_amount: 20900,
				discount_amount: 1290,
				total_amount: 20900,
				timestamp: '05/22 01:10 pm',
			},
			request_items: [
				{
					side: 'asg',
					status: 'approved',
					requested_amount: 1120,
					timestamp: '07/21 02:03 pm',
					occurred_at: '2026-07-21T14:03:00.000-05:00',
				},
				{
					side: 'asg',
					status: 'denied',
					requested_amount: 940,
					timestamp: '07/24 04:32 pm',
					occurred_at: '2026-07-24T16:32:00.000-05:00',
				},
			],
		},
	},
	{
		id: 108,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.BUY_FEE_DISCOUNT,
		sale_type_auction: true,
		vehicle_id: 70004,
		vehicle_title: '2020 Nissan Altima S',
		vehicle_vin: '1N4BL4BV1LC127318',
		vehicle_mileage: 62408,
		vehicle_financial_datum: {
			avg_value: 20400,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				absolute_sale_guarantee_status: null,
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				requested_amount: 1290,
				status: 'ready',
			},
			previous_request: {
				dealership_name: 'Sunset Hills Subaru of New England',
				status: 'denied',
				requested_amount: 910,
				requested_by: 'Megan Carter',
				reason: 'win back',
			},
		},
		activity_history: {
			sold_item: {
				side: 'buy_fee',
				sold_amount: 19800,
				discount_amount: 1290,
				total_amount: 19800,
				timestamp: '05/25 10:40 am',
			},
			request_items: [
				{
					side: 'buy_fee',
					status: 'approved',
					requested_amount: 980,
					timestamp: '07/20 09:18 am',
					occurred_at: '2026-07-20T09:18:00.000-05:00',
				},
				{
					side: 'buy_fee',
					status: 'denied',
					requested_amount: 910,
					timestamp: '07/24 04:32 pm',
					occurred_at: '2026-07-24T16:32:00.000-05:00',
				},
			],
		},
	},
	{
		id: 106,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.BUY_FEE_DISCOUNT,
		sale_type_auction: false,
		vehicle_status: VEHICLE_STATUS.active,
		vehicle_id: 70005,
		vehicle_title: '2019 Hyundai Tucson SEL',
		vehicle_vin: 'KM8J3CA46KU921578',
		vehicle_mileage: 73102,
		vehicle_financial_datum: {
			avg_value: 17650,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				absolute_sale_guarantee_status: null,
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				requested_amount: 1060,
				status: 'denied',
			},
		},
		activity_history: {
			request_items: [
				{
					side: 'buy_fee',
					status: 'denied',
					requested_amount: 1060,
					timestamp: '07/25 11:04 am',
					occurred_at: '2026-07-25T11:04:00.000-05:00',
				},
			],
		},
	},
	{
		id: 107,
		...BASE_MODAL_HEADER_DATA,
		sale_type_auction: false,
		vehicle_status: VEHICLE_STATUS.sold,
		vehicle_id: 70006,
		vehicle_title: '2016 Ford Escape Titanium',
		vehicle_vin: '1FMCU9J94GUC76210',
		vehicle_mileage: 119846,
		vehicle_financial_datum: {
			avg_value: 12900,
		},
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				asg_requested: '$1,340',
				absolute_sale_guarantee_status: 'na',
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				discount_requested: '$1,340',
				status: 'approved',
			},
		},
		activity_history: {
			request_items: [
				{
					side: 'buy_fee',
					status: 'approved',
					requested_amount: '$1,340',
					timestamp: '07/24 08:05 am',
					occurred_at: '2026-07-24T08:05:00.000-05:00',
				},
			],
		},
	},
	{
		id: 109,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.BUY_FEE_DISCOUNT,
		sale_type_auction: true,
		vehicle_status: VEHICLE_STATUS.active,
		vehicle_id: 70007,
		vehicle_title: '2021 Kia Sorento S',
		vehicle_vin: '5XYRL4LC7MG086214',
		vehicle_mileage: 58310,
		vehicle_financial_datum: {
			avg_value: 23100,
		},
		buy_side_rep: true,
		can_act: false,
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				absolute_sale_guarantee_status: null,
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				requested_amount: 1340,
				status: 'approved',
			},
		},
		activity_history: {
			request_items: [
				{
					side: 'buy_fee',
					status: 'approved',
					requested_amount: 1340,
					timestamp: '07/24 08:05 am',
					occurred_at: '2026-07-24T08:05:00.000-05:00',
				},
			],
		},
	},
	{
		id: 110,
		...BASE_MODAL_HEADER_DATA,
		approval_request_summary: APPROVAL_REQUEST_SUMMARY.BUY_FEE_DISCOUNT,
		sale_type_auction: true,
		vehicle_id: 70007,
		vehicle_title: '2021 Kia Sorento S',
		vehicle_vin: '5XYRL4LC7MG086214',
		vehicle_mileage: 58310,
		vehicle_financial_datum: {
			avg_value: 23100,
		},
		buy_side_rep: true,
		can_act: false,
		deal_context: {
			...BASE_DEAL_CONTEXT,
			current_request: {
				...BASE_DEAL_CONTEXT.current_request,
				absolute_sale_guarantee_status: null,
			},
		},
		offer_context: {
			...BASE_OFFER_CONTEXT,
			current_request: {
				...BASE_OFFER_CONTEXT.current_request,
				requested_amount: 1220,
				status: 'requested',
			},
		},
		activity_history: {
			sold_item: {
				side: 'buy_fee',
				sold_amount: 18400,
				discount_amount: 1220,
				total_amount: 18400,
				timestamp: '05/28 03:31 pm',
			},
			request_items: [],
		},
	},
];

export const DISCOUNT_CARD_MOCK_ROWS = RAW_DISCOUNT_CARD_MOCK_ROWS.map((row) => ({
	...row,
	deal_context: {
		...row.deal_context,
		current_request: {
			...row.deal_context.current_request,
			request_id: row.deal_context.current_request?.request_id || row.id * 10 + 1,
		},
	},
	offer_context: {
		...row.offer_context,
		current_request: {
			...row.offer_context.current_request,
			request_id: row.offer_context.current_request?.request_id || row.id * 10 + 2,
		},
	},
}));
